export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/arrow-left.4b2568ab.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};